import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnSavedChangesServiceService {

  public hasUnsavedChanges: boolean = false;

  private checkSubject = new Subject<(result: boolean) => void>();
  public check$ = this.checkSubject.asObservable();

  // Emits when a check is requested
  public checkRequest$ = new Subject<void>();
  // Emits when the component is done (true=proceed, false=cancel)
  // public checkResponse$ = new Subject<boolean>();
  private checkResponseSubject = new ReplaySubject<boolean>(1);
  public checkResponse$ = this.checkResponseSubject.asObservable();

  constructor() { }

  checkUnsavedChanges(callback: (result: boolean) => void) {
    console.log("Checking unsaved changes");
    console.log(this.checkSubject);
    this.checkSubject.next(callback);
  }

  // Called by parent to request a check
  requestCheck() {
    // Clear previous response before requesting new check
    this.checkResponseSubject = new ReplaySubject<boolean>(1);
    this.checkResponse$ = this.checkResponseSubject.asObservable();
    this.checkRequest$.next();
  }

  // Called by component to respond
  respondCheck(result: boolean) {
    console.log("Responding to unsaved changes check with:", result);
    this.checkResponseSubject.next(result);
  }
}
